// Use the current environment for every game/challenge link.
export const resultsUrl = id => `${window.location.origin}/play/casual?puzzle_id=${encodeURIComponent(id)}`;
export const facebookShareUrl = url => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
const elapsed = seconds => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
export const resultText = result => `${result.player || "A homie"} solved ${result.title} on HHKD! ${result.score} points${Number.isFinite(result.seconds) ? ` · ${elapsed(result.seconds)}` : ""}. Think you can beat that?`;

export async function copyShare(text, url) {
  if (!navigator.clipboard?.writeText) throw new Error("Copy the text and link shown below.");
  await navigator.clipboard.writeText(`${text}\n${url}`);
}

export function downloadCard(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Call directly from the click: do not await card generation before native share.
export async function instagramShare(blob, filename, text, url) {
  if (!blob) throw new Error("Your image is preparing. Try Instagram again in a moment, or use Copy.");
  if (typeof File === "function" && typeof navigator.share === "function" && typeof navigator.canShare === "function") {
    const files = [new File([blob], filename, { type: "image/png" })];
    if (navigator.canShare({ files })) {
      try {
        // An image-only ACTION_SEND keeps image targets (including Instagram)
        // eligible. Captions/links are provided separately; targets may discard them.
        await navigator.share({ files });
        return "shared";
      } catch (error) {
        if (error.name === "AbortError") throw error;
        // Embedded Preview and some browsers block file sharing despite canShare.
      }
    }
  }
  downloadCard(blob, filename);
  return "downloaded";
}

export async function shareImageAndLink(blob, filename, text, url) {
  if (!blob) throw new Error("Your image is preparing. Try again in a moment.");
  if (typeof File === "function" && navigator.share && navigator.canShare) {
    const files = [new File([blob], filename, { type: blob.type || "image/png" })];
    if (navigator.canShare({ files })) {
      // Put the tappable URL in the message as well as in the image. Android
      // receivers vary in their handling of a separate URL plus files.
      await navigator.share({ files, title: "Squab Wit Da Homie · HHKD", text: `${text}\n${url}` });
      return "shared";
    }
  }
  downloadCard(blob, filename);
  return "downloaded";
}

export async function resultsCard(result) {
  const canvas = document.createElement("canvas");
  canvas.width = 1080; canvas.height = 1080;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Image cards are unavailable. Use Copy instead.");
  ctx.fillStyle = "#140b23"; ctx.fillRect(0, 0, 1080, 1080);
  ctx.strokeStyle = "#ffd45a"; ctx.lineWidth = 8; ctx.strokeRect(24, 24, 1032, 1032);
  const line = (text, y, size, color = "#fff4cb") => {
    ctx.fillStyle = color;
    let fontSize = size;
    do { ctx.font = `bold ${fontSize--}px sans-serif`; } while (ctx.measureText(String(text)).width > 930 && fontSize > 10);
    ctx.fillText(String(text), 72, y);
  };
  line("HIP HOP KNOWLEDGE DROP", 135, 42, "#ffd45a");
  line("NEW JACK", 235, 42, "#63f8ff");
  line("PUZZLE SOLVED!", 370, 88, "#ffd45a");
  line(result.player || "A homie", 475, 56);
  line(result.title, 560, 38);
  line(`${result.score} POINTS`, 710, 94, "#ffd45a");
  line(`${Number.isFinite(result.seconds) ? `${elapsed(result.seconds)} · ` : ""}THINK YOU CAN BEAT THAT?`, 805, 36);
  line(window.location.host, 920, 32, "#63f8ff");
  line(resultsUrl(result.puzzleId), 985, 20);
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("Couldn't create the results image. Use Copy instead.")), "image/png"));
}
